export default __webpack_public_path__ + "static/media/logo-horiz-branco.788145a6.png";